function updateDiscountProgress() {
  const discountThreshold = 300; // 💰 subtotal required to unlock discount
  const discountAmount = 25;     // 🎁 value of the discount

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const subtotal = cart.items.reduce((sum, item) => {
            return sum + (item.original_price * item.quantity);
          }, 0) / 100;

      const container = document.getElementById('discount-progress-container');
      const bar = document.getElementById('discount-progress-bar');
      const message = document.getElementById('discount-message');

      if (!container || !bar || !message) return;

      if (subtotal > 0) {
        container.style.display = 'flex';

        // Use threshold for progress calculation
        const progress = Math.min(subtotal / discountThreshold, 1);
        bar.style.width = (progress * 100) + '%';

        if (subtotal >= discountThreshold) {
          if (!sessionStorage.getItem('confettiFired')) {
            launchCanvasConfettiExplosion(); // 🎉 blast confetti
            sessionStorage.setItem('confettiFired', 'true');
          }

          container.classList.add('discount-unlocked');
          message.innerText = `🎉 You unlocked $${discountAmount} off your order!`;
          bar.style.backgroundColor = '#F47A14';
        } else {
          // Allow confetti to re-trigger if user drops below threshold
          sessionStorage.removeItem('confettiFired');

          container.classList.remove('discount-unlocked');
          const dollarsLeft = (discountThreshold - subtotal).toFixed(2);
          message.innerText = `Spend $${dollarsLeft} more to unlock $${discountAmount} off.`;
          bar.style.backgroundColor = '#00a0e4';
        }

      } else {
        container.style.display = 'none';
      }
    });
}


// Listen for custom event dispatched after cart updates
document.addEventListener('cart:updated', updateDiscountProgress);

// Optional: Run once on initial load (cart drawer may be open)
document.addEventListener('DOMContentLoaded', () => {
  updateDiscountProgress(); 
});

function launchCanvasConfettiExplosion() {
  const canvas = document.getElementById('confetti-canvas');
  const ctx = canvas.getContext('2d');
  canvas.width = window.innerWidth;
  canvas.height = 500;

  const colors = ['#ff595e', '#ffca3a', '#8ac926', '#1982c4', '#6a4c93'];
  const confettiParticles = [];

  const gravity = 0.5;
  const terminalVelocity = 5;
  const drag = 0.075;

  for (let i = 0; i < 80; i++) {
    const angle = Math.random() * Math.PI * 2;
    const velocity = Math.random() * 35 + 20;

    confettiParticles.push({
      x: canvas.width / 2,
      y: canvas.height,
      color: colors[Math.floor(Math.random() * colors.length)],
      size: Math.random() * 6 + 4,
      tilt: Math.random() * 10 - 5,
      tiltAngle: Math.random() * Math.PI,
      vx: Math.cos(angle) * velocity,
      vy: Math.sin(angle) * velocity * -1,
      opacity: 1,
      rotation: Math.random() * 360
    });
  }

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    confettiParticles.forEach(p => {
      ctx.beginPath();
      ctx.fillStyle = p.color;
      ctx.globalAlpha = p.opacity;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.tiltAngle);
      ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size);
      ctx.restore();
    });

    updateParticles();
    requestAnimationFrame(draw);
  }

  function updateParticles() {
    confettiParticles.forEach((p, i) => {
      p.vy += gravity;
      p.vy = Math.min(p.vy, terminalVelocity);
      p.vx *= (1 - drag);
      p.vy *= (1 - drag);
      p.x += p.vx;
      p.y += p.vy;
      p.tiltAngle += 0.05;
      p.opacity -= 0.005;;

      if (p.opacity <= 0) confettiParticles.splice(i, 1);
    });
  }

  draw();
}
